/**
 * wfaMSG
 * Version: 1.0.0
 * 
 * wfaMSG is a javascript library that allows an easy workaround for the limitation set in place
 * by the Same Origin Policy.  It allow easy communication and the ability to expose javascript
 * API's across domain boundaries using the native PostMessage protocol.
 * 
 * Implementation guidelines can be found at _documentation/SSEP/wfaMSG/wfaMSG_Guide.docx
 * 
 */

(function (window, document, location, setTimeout, decodeURIComponent, encodeURIComponent) {
    var globalScope = this;
    var thisChannelId = Math.floor(Math.random() * 10000); // randomize the initial id in case of multiple closures loaded 
    var regexURI = /^((http.?:)\/\/([^:\/\s]+)(:\d+)*)/; // returns groups for protocol (2), domain (3) and port (4) 
    var regexParent = /[\-\w]+\/\.\.\//; // matches a foo/../ expression 
    var regexDoubleSlash = /([^:])\/\//g; // matches // anywhere but in the protocol
    var namespace = ""; // stores namespace under which wfaMSG object is stored on the page (empty if object is globalScope)
    var wfaMSG = {};
    var _wfaMSG = window.wfaMSG; // map over globalScope wfaMSG in case of overwrite
    var IFRAME_PREFIX = "wfaMSG_";
    
    /*
     * Feature detection
     */
    function isHostMethod(object, property){
      var t = typeof object[property];
      return t == 'function' ||
                  (!!(t == 'object' && object[property])) ||
                  t == 'unknown';
    }
    
    function isHostObject(object, property){
      return !!(typeof(object[property]) == 'object' && object[property]);
    }
    
    function isArray(o){
      return o.prop && o.prop.constructor === Array;
    }
    
    /*
     * jQuery-like mplementation of adding and removing event listeners.
     */
    var on, un;
    on = function(target, type, listener){
      target.addEventListener(type, listener, false);
    };
    un = function(target, type, listener){
      target.removeEventListener(type, listener, false);
    };
    
    /*
     * Cross Browser implementation of DOMContentLoaded.
     */
    var domIsReady = false, 
        domReadyQueue = [], 
        readyState;
    try {
      readyState = document.readyState;
      // If the browser is WebKit enabled, check for both "loaded" and "interactive" states (HTML5 specs)
      domIsReady = readyState === "complete" || ((navigator.userAgent.indexOf('AppleWebKit/') > 0) && (readyState === "loaded" || readyState === "interactive"));
    }
    catch(e) { }
    
    function domOnReady(){
      if (domIsReady) {
        return;
      }
      domIsReady = true;
      for (var i = 0; i < domReadyQueue.length; i++) {
        domReadyQueue[i]();
      }
      domReadyQueue.length = 0;
    }
    
    if (!domIsReady) {
      on(document, "DOMContentLoaded", domOnReady);
     
      // A fallback to window.onload, that will always work
      on(window, "load", domOnReady);
    }
    
    /**
     * This will add a function to the queue of functions to be run once the DOM reaches a ready state.
     * If functions are added after this event then they will be executed immediately.
     * @param {function} fn The function to add
     * @param {Object} scope An optional scope for the function to be called with.
     */
    function whenDomReady(fn, scope){
      if (domIsReady) {
        fn.call(scope);
        return;
      }
      domReadyQueue.push(function(){
        fn.call(scope);
      });
    }
    
    /**
     * Returns an instance of wfaMSG from the parent window with
     * respect to the namespace.
     *
     * @return An instance of wfaMSG (in the parent window)
     */
    function getParentObject(){
      var obj = parent;
      if (namespace !== "") {
        for (var i = 0, ii = namespace.split("."); i < ii.length; i++) {
          obj = obj[ii[i]];
        }
      }
      return obj.wfaMSG;
    }
    
    /**
     * Removes wfaMSG variable from the globalScope. It also returns control
     * of the wfaMSG variable to whatever code used it before.
     *
     * @param {String} ns A string representation of an object that will hold
     *                    an instance of wfaMSG.
     * @return An instance of wfaMSG
     */
    function noConflict(ns){
      window.wfaMSG = _wfaMSG;
      namespace = ns;
      if (namespace) {
        IFRAME_PREFIX = "wfaMSG_" + namespace.replace(".", "_") + "_";
      }
      return wfaMSG;
    }
    
    /*
     * Methods for working with URLs
     */
    /**
     * Get the domain name from a url.
     * @param {String} url The url to extract the domain from.
     * @return The domain part of the url.
     * @type {String}
     */
    function getDomainName(url){
      return url.match(regexURI)[3];
    }
    
    /**
     * Get the port for a given URL, or "" if none
     * @param {String} url The url to extract the port from.
     * @return The port part of the url.
     * @type {String}
     */
    function getPort(url){
      return url.match(regexURI)[4] || "";
    }
    
    /**
     * Returns  a string containing the schema, domain and if present the port
     * @param {String} url The url to extract the location from
     * @return {String} The location part of the url
     */
    function getLocation(url){
      var m = url.toLowerCase().match(regexURI);
      var proto = m[2], domain = m[3], port = m[4] || "";
      if ((proto == "http:" && port == ":80") || (proto == "https:" && port == ":443")) {
        port = "";
      }
      return proto + "//" + domain + port;
    }
    
    /**
     * Resolves a relative url into an absolute one.
     * @param {String} url The path to resolve.
     * @return {String} The resolved url.
     */
    function resolveUrl(url){
        
      // replace all // except the one in proto with /
      url = url.replace(regexDoubleSlash, "$1/");
      
      // If the url is a valid url we do nothing
      if (!url.match(/^(http||https):\/\//)) {
        // If this is a relative path
        var path = (url.substring(0, 1) === "/") ? "" : location.pathname;
        if (path.substring(path.length - 1) !== "/") {
          path = path.substring(0, path.lastIndexOf("/") + 1);
        }
        
        url = location.protocol + "//" + location.host + path + url;
      }
      
      // reduce all 'xyz/../' to just '' 
      while (regexParent.test(url)) {
        url = url.replace(regexParent, "");
      }
      
      return url;
    }
    
    /**
     * Appends the parameters to the given url.
     * The base url can contain existing query parameters.
     * @param {String} url The base url.
     * @param {Object} parameters The parameters to add.
     * @return {String} A new valid url with the parameters appended.
     */
    function appendQueryParameters(url, parameters){
        
      var hash = "", indexOf = url.indexOf("#");
      if (indexOf !== -1) {
        hash = url.substring(indexOf);
        url = url.substring(0, indexOf);
      }
      var q = [];
      for (var key in parameters) {
        if (parameters.hasOwnProperty(key)) {
          q.push(key + "=" + encodeURIComponent(parameters[key]));
        }
      }
      return url + (url.indexOf("?") == -1 ? "?" : "&") + q.join("&") + hash;
    }
    
    
    // build the query object either from location.query, if it contains the xdm_e argument, or from location.hash
    var query = (function(input) {
      input = input.substring(1).split("&");
      var data = {}, pair, i = input.length;
      while (i--) {
        pair = input[i].split("=");
        data[pair[0]] = decodeURIComponent(pair[1]);
      }
      return data;
    }(/xdm_e=/.test(location.search) ? location.search : location.hash));
    
    /*
     * Helper methods
     */
    /**
     * Helper for checking if a variable/property is undefined
     * @param {Object} v The variable to test
     * @return {Boolean} True if the passed variable is undefined
     */
    function undef(v){
      return typeof v === "undefined";
    }
    
    /**
     * Applies properties from the source object to the target object.
     * @param {Object} target The target of the properties.
     * @param {Object} source The source of the properties.
     * @param {Boolean} noOverwrite Set to True to only set non-existing properties.
     */
    function apply(destination, source, noOverwrite){
      var member;
      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          if (prop in destination) {
            member = source[prop];
            if (typeof member === "object") {
              apply(destination[prop], member, noOverwrite);
            }
            else if (!noOverwrite) {
              destination[prop] = source[prop];
            }
          }
          else {
            destination[prop] = source[prop];
          }
        }
      }
      return destination;
    }
    
    /**
     * Creates a frame and appends it to the DOM.
     * @param config {object} This object can have the following properties
     * <ul>
     * <li> {object} prop The properties that should be set on the frame. This should include the 'src' property.</li>
     * <li> {object} attr The attributes that should be set on the frame.</li>
     * <li> {DOMElement} container Its parent element (Optional).</li>
     * <li> {function} onLoad A method that should be called with the frames contentWindow as argument when the frame is fully loaded. (Optional)</li>
     * </ul>
     * @return The frames DOMElement
     * @type DOMElement
     */
    function createFrame(config){
      var frame;
      frame = document.createElement("IFRAME");
      frame.name = config.props.name;
      frame.id = frame.name = config.props.name;
      delete config.props.name;
      
      if (typeof config.container == "string") {
        config.container = document.getElementById(config.container);
      }
      
      if (!config.container) {
        // This needs to be hidden like this, simply setting display:none and the like will cause failures in some browsers.
        apply(frame.style, {
          position: "absolute",
          top: "-2000px",
          // Avoid potential horizontal scrollbar
          left: "0px"
        });
        config.container = document.body;
      }
        
      // HACK: IE cannot have the src attribute set when the frame is appended
      //       into the container, so we set it to "javascript:false" as a
      //       placeholder for now.  If we left the src undefined, it would
      //       instead default to "about:blank", which causes SSL mixed-content
      //       warnings in IE6 when on an SSL parent page.
      var src = config.props.src;
      config.props.src = "javascript:false";
      
      // Additional attributes to hide the iframe from readers
      frame.setAttribute('aria-hidden','true');
      frame.setAttribute('tabindex','-1');
      frame.setAttribute('title','intentionally blank');
      
      // transfer properties to the frame
      apply(frame, config.props);
      
      frame.border = frame.frameBorder = 0;
      frame.allowTransparency = true;
      config.container.appendChild(frame);
      
      if (config.onLoad) {
          on(frame, "load", config.onLoad);
      }
        
      // set the frame URL to the proper value (we previously set it to
      // "javascript:false" to work around the IE issue mentioned above)
      if(config.usePost) {
        var form = config.container.appendChild(document.createElement('form')), input;
        form.target = frame.name;
        form.action = src;
        form.method = 'POST';
        if (typeof(config.usePost) === 'object') {
          for (var i in config.usePost) {
            if (config.usePost.hasOwnProperty(i)) {
              input = document.createElement("INPUT");
              input.name = i;
              input.value = config.usePost[i];
              form.appendChild(input);
            }
          }
        }
        form.submit();
        form.parentNode.removeChild(form);
      } 
      else {
        frame.src = src;
      }
      config.props.src = src;
      
      return frame;
    }
    
    /**
     * Check whether a domain is allowed using an Access Control List.
     * The ACL can contain * and ? as wildcards, or can be regular expressions.
     * If regular expressions they need to begin with ^ and end with $.
     * @param {Array/String} acl The list of allowed domains
     * @param {String} domain The domain to test.
     * @return {Boolean} True if the domain is allowed, false if not.
     */
    function checkAcl(acl, domain){
      // normalize into an array
      if (typeof acl == "string") {
        acl = [acl];
      }
      var re, i = acl.length;
      while (i--) {
        re = acl[i];
        re = new RegExp(re.substr(0, 1) == "^" ? re : ("^" + re.replace(/(\*)/g, ".$1").replace(/\?/g, ".") + "$"));
        if (re.test(domain)) {
          return true;
        }
      }
      return false;
    }
    
    /*
     * Functions related to stacks
     */
    /**
     * Prepares an array of stack-elements suitable for the current configuration
     * @param {Object} config The Transports configuration. See wfaMSG.Socket for more.
     * @return {Array} An array of stack-elements with the TransportElement at index 0.
     */
    function prepareTransportStack(config){
      var protocol = config.protocol, stackEls;
      config.isHost = config.isHost || undef(query.xdm_p);
      
      if (!config.props) {
          config.props = {};
      }
      if (!config.isHost) {
        config.channel = query.xdm_c.replace(/["'<>\\]/g, "");
        config.secret = query.xdm_s;
        config.remote = query.xdm_e.replace(/["'<>\\]/g, "");
        
        protocol = query.xdm_p;
        if (config.acl && !checkAcl(config.acl, config.remote)) {
          throw new Error("Access denied for " + config.remote);
        }
      }
      else {
        config.remote = resolveUrl(config.remote);
        config.channel = config.channel || "default" + thisChannelId++;
        config.secret = Math.random().toString(16).substring(2);
        if (undef(protocol)) {
          if (getLocation(location.href) == getLocation(config.remote)) {
              /*
               * Both documents has the same origin, lets use direct access.
               */
              protocol = "4";
          }
          else if (isHostMethod(window, "postMessage") || isHostMethod(document, "postMessage")) {
            /*
             * This is supported in IE8+, Firefox 3+, Opera 9+, Chrome 2+ and Safari 4+
             */
            protocol = "1";
          }
        }
      }
      config.protocol = protocol; // for conditional branching
      switch (protocol) {
        case "1":
          stackEls = [new wfaMSG.stack.PostMessageTransport(config)];
          break;
        case "4":
          stackEls = [new wfaMSG.stack.SameOriginTransport(config)];
          break;
      }
      // this behavior is responsible for buffering outgoing messages, and for performing lazy initialization
      stackEls.push(new wfaMSG.stack.QueueBehavior({
        lazy: config.lazy,
        remove: true
      }));
      return stackEls;
    }
    
    /**
     * Chains all the separate stack elements into a single usable stack.
     * If an element is missing a necessary method then it will have a pass-through method applied.
     * @param {Array} stackElements An array of stack elements to be linked.
     * @return {wfaMSG.stack.StackElement} The last element in the chain.
     */
    function chainStack(stackElements){
      var stackEl, 
          defaults = {
            incoming: function(message, origin){
              this.up.incoming(message, origin);
            },
            outgoing: function(message, recipient){
              this.down.outgoing(message, recipient);
            },
            callback: function(success){
              this.up.callback(success);
            },
            init: function(){
              this.down.init();
            },
            destroy: function(){
              this.down.destroy();
            }
          };
      for (var i = 0, len = stackElements.length; i < len; i++) {
        stackEl = stackElements[i];
        apply(stackEl, defaults, true);
        if (i !== 0) {
          stackEl.down = stackElements[i - 1];
        }
        if (i !== len - 1) {
          stackEl.up = stackElements[i + 1];
        }
      }
      return stackEl;
    }
    
    /**
     * This will remove a stackelement from its stack while leaving the stack functional.
     * @param {Object} element The elment to remove from the stack.
     */
    function removeFromStack(element){
      element.up.down = element.down;
      element.down.up = element.up;
      element.up = element.down = null;
    }
    
    /*
     * Export the main object and any other methods applicable
     */
    /** 
     * @class wfaMSG
     * A javascript library providing cross-browser, cross-domain messaging.
     * @version 1.0.0
     * @singleton
     */
    apply(wfaMSG, {
      /**
       * The version of the library
       * @type {string}
       */
      version: "1.0.0",
      /**
       * This is a map containing all the query parameters passed to the document.
       * All the values has been decoded using decodeURIComponent.
       * @type {object}
       */
      query: query,
      /**
       * @private
       */
      stack: {},
      /**
       * Applies properties from the source object to the target object.
       * @param {object} target The target of the properties.
       * @param {object} source The source of the properties.
       * @param {boolean} noOverwrite Set to True to only set non-existing properties.
       */
      apply: apply,
      /**
       * This will add a function to the queue of functions to be run once the DOM reaches a ready state.
       * If functions are added after this event then they will be executed immediately.
       * @param {function} fn The function to add
       * @param {object} scope An optional scope for the function to be called with.
       */
      whenDomReady: whenDomReady,
      /**
       * Removes wfaMSG variable from the globalScope. It also returns control
       * of the wfaMSG variable to whatever code used it before.
       *
       * @param {String} ns A string representation of an object that will hold
       *                    an instance of wfaMSG.
       * @return An instance of wfaMSG
       */
      noConflict: noConflict
    });
    
    /** 
     * @class wfaMSG.DomHelper
     * Contains methods for dealing with the DOM
     * @singleton
     */
    wfaMSG.DomHelper = {
      /**
       * Provides a consistent interface for adding eventhandlers
       * @param {Object} target The target to add the event to
       * @param {String} type The name of the event
       * @param {Function} listener The listener
       */
      on: on,
      /**
       * Provides a consistent interface for removing eventhandlers
       * @param {Object} target The target to remove the event from
       * @param {String} type The name of the event
       * @param {Function} listener The listener
       */
      un: un
    };
    
    (function(){
      // The map containing the stored functions
      var _map = {};
      
      /**
       * @class wfaMSG.Fn
       * This contains methods related to function handling, such as storing callbacks.
       * @singleton
       * @namespace wfaMSG
       */
      wfaMSG.Fn = {
        /**
         * Stores a function using the given name for reference
         * @param {String} name The name that the function should be referred by
         * @param {Function} fn The function to store
         * @namespace wfaMSG.fn
         */
        set: function(name, fn){
          _map[name] = fn;
        },
        /**
         * Retrieves the function referred to by the given name
         * @param {String} name The name of the function to retrieve
         * @param {Boolean} del If the function should be deleted after retrieval
         * @return {Function} The stored function
         * @namespace wfaMSG.fn
         */
        get: function(name, del){
          if (!_map.hasOwnProperty(name)) {
            return;
          }
          var fn = _map[name];
          
          if (del) {
            delete _map[name];
          }
          return fn;
        }
      };
        
    }());
    
    /**
     * @class wfaMSG.Socket
     * This class creates a transport channel between two domains that is usable for sending and receiving string-based messages.
     * The channel is reliable, supports queueing, and ensures that the message originates from the expected domain.
     * Internally different stacks will be used depending on the browsers features and the available parameters.
     * <h2>How to set up</h2>
     * Setting up the provider:
     * <pre><code>
     * var socket = new wfaMSG.Socket({
     * &nbsp; local: "name.html",
     * &nbsp; onReady: function(){
     * &nbsp; &nbsp; &#47;&#47; you need to wait for the onReady callback before using the socket
     * &nbsp; &nbsp; socket.postMessage("foo-message");
     * &nbsp; },
     * &nbsp; onMessage: function(message, origin) {
     * &nbsp;&nbsp; alert("received " + message + " from " + origin);
     * &nbsp; }
     * });
     * </code></pre>
     * Setting up the consumer:
     * <pre><code>
     * var socket = new wfaMSG.Socket({
     * &nbsp; remote: "http:&#47;&#47;remotedomain/page.html",
     * &nbsp; remoteHelper: "http:&#47;&#47;remotedomain/name.html",
     * &nbsp; onReady: function(){
     * &nbsp; &nbsp; &#47;&#47; you need to wait for the onReady callback before using the socket
     * &nbsp; &nbsp; socket.postMessage("foo-message");
     * &nbsp; },
     * &nbsp; onMessage: function(message, origin) {
     * &nbsp;&nbsp; alert("received " + message + " from " + origin);
     * &nbsp; }
     * });
     * </code></pre>
     * If you are unable to upload the <code>name.html</code> file to the consumers domain then remove the <code>remoteHelper</code> property
     * and wfaMSG will fall back to using the HashTransport instead of the NameTransport when not able to use any of the primary transports.
     * @namespace wfaMSG
     * @constructor
     * @cfg {String/Window} local The url to the local name.html document, a local static file, or a reference to the local window.
     * @cfg {Boolean} lazy (Consumer only) Set this to true if you want wfaMSG to defer creating the transport until really needed. 
     * @cfg {String} remote (Consumer only) The url to the providers document.
     * @cfg {String} remoteHelper (Consumer only) The url to the remote name.html file. This is to support NameTransport as a fallback. Optional.
     * @cfg {Number} delay The number of milliseconds wfaMSG should try to get a reference to the local window.  Optional, defaults to 2000.
     * @cfg {Number} interval The interval used when polling for messages. Optional, defaults to 300.
     * @cfg {String} channel (Consumer only) The name of the channel to use. Can be used to set consistent iframe names. Must be unique. Optional.
     * @cfg {Function} onMessage The method that should handle incoming messages. This method should accept two arguments, the message as a string, and the origin as a string. Optional.
     * @cfg {Function} onReady A method that should be called when the transport is ready. Optional.
     * @cfg {DOMElement|String} container (Consumer only) The element, or the id of the element that the primary iframe should be inserted into. If not set then the iframe will be positioned off-screen. Optional.
     * @cfg {Array/String} acl (Provider only) Here you can specify which '[protocol]://[domain]' patterns that should be allowed to act as the consumer towards this provider.
     * This can contain the wildcards ? and *.  Examples are 'http://example.com', '*.foo.com' and '*dom?.com'. If you want to use reqular expressions then you pattern needs to start with ^ and end with $.
     * If none of the patterns match an Error will be thrown.  
     * @cfg {Object} props (Consumer only) Additional properties that should be applied to the iframe. This can also contain nested objects e.g: <code>{style:{width:"100px", height:"100px"}}</code>. 
     * Properties such as 'name' and 'src' will be overrided. Optional.
     */
    wfaMSG.Socket = function(config){
      // create the stack
      var stack = chainStack(prepareTransportStack(config).concat([{
         incoming: function (message, origin) {
           if (config.onMessage === 'function') {
             config.onMessage(message, origin);
           }           
        },
        callback: function(success){
          if (config.onReady) {
              config.onReady(success);
          }
        }
      }])), recipient = getLocation(config.remote);
      
      // set the origin
      this.origin = getLocation(config.remote);
    
      /**
       * Initiates the destruction of the stack.
       */
      this.destroy = function(){
        stack.destroy();
      };
      
      /**
       * Posts a message to the remote end of the channel
       * @param {String} message The message to send
       */
      this.postMessage = function(message){
        stack.outgoing(message, recipient);
      };
      
      stack.init();
    };
    
    /**
     * @class wfaMSG.stack.SameOriginTransport
     * SameOriginTransport is a transport class that can be used when both domains have the same origin.
     * This can be useful for testing and for when the main application supports both internal and external sources.
     * @namespace wfaMSG.stack
     * @constructor
     * @param {Object} config The transports configuration.
     * @cfg {String} remote The remote document to communicate with.
     */
    wfaMSG.stack.SameOriginTransport = function(config){
      var pub, frame, send, targetOrigin;
      
      return (pub = {
          outgoing: function(message, domain, fn){
              send(message);
              if (fn) {
                  fn();
              }
          },
          destroy: function(){
              if (frame) {
                  frame.parentNode.removeChild(frame);
                  frame = null;
              }
          },
        onDOMReady: function(){
          targetOrigin = getLocation(config.remote);
          
          if (config.isHost) {
            // set up the iframe
            apply(config.props, {
              src: appendQueryParameters(config.remote, {
                xdm_e: location.protocol + "//" + location.host + location.pathname,
                xdm_c: config.channel,
                xdm_p: 4 // 4 = SameOriginTransport
              }),
              name: IFRAME_PREFIX + config.channel + "_provider"
            });
            frame = createFrame(config);
            wfaMSG.Fn.set(config.channel, function(sendFn){
              send = sendFn;
              setTimeout(function(){
                pub.up.callback(true);
              }, 0);
              return function(msg){
                pub.up.incoming(msg, targetOrigin);
              };
            });
          }
          else {
            send = getParentObject().Fn.get(config.channel, true)(function(msg){
              pub.up.incoming(msg, targetOrigin);
            });
            setTimeout(function(){
              pub.up.callback(true);
            }, 0);
          }
        },
        init: function(){
          whenDomReady(pub.onDOMReady, pub);
        }
      });
    };
    
    /**
     * @class wfaMSG.stack.PostMessageTransport
     * PostMessageTransport is a transport class that uses HTML5 postMessage for communication.
     * <a href="http://msdn.microsoft.com/en-us/library/ms644944(VS.85).aspx">http://msdn.microsoft.com/en-us/library/ms644944(VS.85).aspx</a>
     * <a href="https://developer.mozilla.org/en/DOM/window.postMessage">https://developer.mozilla.org/en/DOM/window.postMessage</a>
     * @namespace wfaMSG.stack
     * @constructor
     * @param {Object} config The transports configuration.
     * @cfg {String} remote The remote domain to communicate with.
     */
    wfaMSG.stack.PostMessageTransport = function(config){
      var pub, // the public interface
          frame, // the remote frame, if any
          callerWindow, // the window that we will call with
          targetOrigin; // the domain to communicate with
      /**
       * Resolves the origin from the event object
       * @private
       * @param {Object} event The messageevent
       * @return {String} The scheme, host and port of the origin
       */
      function _getOrigin(event){
        if (event.origin) {
          // This is the HTML5 property
          return getLocation(event.origin);
        }
        if (event.uri) {
          // From earlier implementations 
          return getLocation(event.uri);
        }
        if (event.domain) {
          // This is the last option and will fail if the 
          // origin is not using the same schema as we are
          return location.protocol + "//" + event.domain;
        }
        throw "Unable to retrieve the origin of the event";
      }
        
      /**
       * This is the main implementation for the onMessage event.
       * It checks the validity of the origin and passes the message on if appropriate.
       * @private
       * @param {Object} event The messageevent
       */
      function _window_onMessage(event){
        var origin = _getOrigin(event);
        if (origin == targetOrigin && event.data.substring(0, config.channel.length + 1) == config.channel + " ") {
          pub.up.incoming(event.data.substring(config.channel.length + 1), origin);
        }
      }
        
      return (pub = {
        outgoing: function(message, domain, fn){
          callerWindow.postMessage(config.channel + " " + message, domain || targetOrigin);
          if (fn) {
            fn();
          }
        },
        destroy: function(){
          un(window, "message", _window_onMessage);
          if (frame) {
            callerWindow = null;
            frame.parentNode.removeChild(frame);
            frame = null;
          }
        },
        onDOMReady: function(){
          targetOrigin = getLocation(config.remote);
          if (config.isHost) {
            // add the event handler for listening
            var waitForReady = function(event){  
              if (event.data == config.channel + "-ready") {
                // replace the eventlistener
                callerWindow = ("postMessage" in frame.contentWindow) ? frame.contentWindow : frame.contentWindow.document;
                un(window, "message", waitForReady);
                on(window, "message", _window_onMessage);
                setTimeout(function(){
                    pub.up.callback(true);
                }, 0);
              }
            };
            on(window, "message", waitForReady);
            
            // set up the iframe
            apply(config.props, {
              src: appendQueryParameters(config.remote, {
                xdm_e: getLocation(location.href),
                xdm_c: config.channel,
                xdm_p: 1 // 1 = PostMessage
              }),
              name: IFRAME_PREFIX + config.channel + "_provider"
            });
            frame = createFrame(config);
          }
          else {
            // add the event handler for listening
            on(window, "message", _window_onMessage);
            callerWindow = ("postMessage" in window.parent) ? window.parent : window.parent.document;
            callerWindow.postMessage(config.channel + "-ready", targetOrigin);
            
            setTimeout(function(){
              pub.up.callback(true);
            }, 0);
          }
        },
        init: function(){
          whenDomReady(pub.onDOMReady, pub);
        }
      });
    };
    
    /**
     * @class wfaMSG.stack.QueueBehavior
     * This is a behavior that enables queueing of messages. 
     * It will buffer incoming messages and dispach these as fast as the underlying transport allows.
     * This will also fragment/defragment messages so that the outgoing message is never bigger than the
     * set length.
     * @namespace wfaMSG.stack
     * @constructor
     * @param {Object} config The behaviors configuration. Optional.
     * @cfg {Number} maxLength The maximum length of each outgoing message. Set this to enable fragmentation.
     */
    wfaMSG.stack.QueueBehavior = function(config){
      var pub, queue = [], waiting = true, incoming = "", destroying, maxLength = 0, lazy = false, doFragment = false;
        
      function dispatch(){
        if (config.remove && queue.length === 0) {
          removeFromStack(pub);
          return;
        }
        if (waiting || queue.length === 0 || destroying) {
          return;
        }
        waiting = true;
        var message = queue.shift();
        
        pub.down.outgoing(message.data, message.origin, function(success){
          waiting = false;
          if (message.callback) {
            setTimeout(function(){
              message.callback(success);
            }, 0);
          }
          dispatch();
        });
      }
      return (pub = {
        init: function() {
          if (undef(config)) {
            config = {};
          }
          if (config.maxLength) {
            maxLength = config.maxLength;
            doFragment = true;
          }
          if (config.lazy) {
            lazy = true;
          }
          else {
            pub.down.init();
          }
        },
        callback: function(success) { 
          waiting = false;
          var up = pub.up; // in case dispatch calls removeFromStack
          dispatch();
          up.callback(success);
        },
        incoming: function(message, origin) {
          if (doFragment) {
            var indexOf = message.indexOf("_"), seq = parseInt(message.substring(0, indexOf), 10);
            incoming += message.substring(indexOf + 1);
            if (seq === 0) {
              if (config.encode) {
                incoming = decodeURIComponent(incoming);
              }
              pub.up.incoming(incoming, origin);
              incoming = "";
            }
          }
          else {
            pub.up.incoming(message, origin);
          }
        },
        outgoing: function(message, origin, fn) {
          if (config.encode) {
            message = encodeURIComponent(message);
          }
    
          var fragments = [], fragment;
          if (doFragment) {
            // fragment into chunks
            while (message.length !== 0) {
              fragment = message.substring(0, maxLength);
              message = message.substring(fragment.length);
              fragments.push(fragment);
            }
            // enqueue the chunks
            while ((fragment = fragments.shift())) {
              queue.push({
                data: fragments.length + "_" + fragment,
                origin: origin,
                callback: fragments.length === 0 ? fn : null
              });
            }
          }
          else {
            queue.push({
              data: message,
              origin: origin,
              callback: fn
            });
          }
          if (lazy) {
            pub.down.init();
          }
          else {
            dispatch();
          }
        },
        destroy: function() {
          destroying = true;
          pub.down.destroy();
        }
      });
    };
    
    globalScope.wfaMSG = wfaMSG;
    })(window, document, location, window.setTimeout, decodeURIComponent, encodeURIComponent);